import * as React from "react";
import { useState } from "react";
import ToggleButton from "../commons/components/buttons/ToggleButton";
import { ModalWarning } from "../commons/components/modal/ModalWarning";

interface PracticeCustomisationOverrideProps {
  value: boolean;
  onValueChange: (boolean) => void;
}

const PracticeCustomisationOverride = (props: PracticeCustomisationOverrideProps) => {
  const [displayWarning, setDisplayWarning] = useState(false);

  const update = (value) => (value ? props.onValueChange(true) : setDisplayWarning(true));

  return (
    <div className={"no-label-field-groups toggle"}>
      <div className="item-highlight">
        {isDmipPlatform &&
          i18n["Page.Settings.Customisation.Branding.PracticeAndDoctor.Customisation"]}
        {!isDmipPlatform && i18n["Page.Settings.Customisation.Branding.Practice.Customisation"]}
      </div>
      <ToggleButton value={props.value} onChange={update} />
      {displayWarning && (
        <ModalWarning
          action={async () => {
            props.onValueChange(false);
            setDisplayWarning(false);
          }}
          cancel={() => setDisplayWarning(false)}
          title={
            i18n["Page.Settings.Customisation.Branding.Practice.Customisation.DisableModal.Title"]
          }
          actionButtonLabel={
            i18n["Page.Settings.Customisation.Branding.Practice.Customisation.DisableModal.Disable"]
          }
        >
          <p>
            {
              i18n[
                "Page.Settings.Customisation.Branding.Practice.Customisation.DisableModal.Content"
              ]
            }
          </p>
        </ModalWarning>
      )}
    </div>
  );
};

export default PracticeCustomisationOverride;
